/**
 * Copyright(c) 2022 Fenix Outdoor International AG.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Fenix ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Fenix.
 *
 */
import React from "react";
import FormGroup from "../../../common/core/FormGroup";
import Input from "../../../common/core/Input";
import Button from "../../../common/core/Button";
import Form from "../../../common/core/Form";
import Logo from "../../../common/assets/images/fenix-logo.svg";

const ForgotPassword = () => (
  <div className="login-outer">
    <div className="login-panel">
      <div className="login-brand">
        <img src={Logo} alt="" />
        <h4>Forgot Password</h4>
      </div>

      <Form>
        <fieldset>
          <FormGroup>
            <Input
              value=""
              onChange=""
              type="email"
              name=""
              id=""
              placeholder="Enter Email ID"
              required
            />
          </FormGroup>
          {/* <p className="text-danger mb-0 fs-xs">
              {error}
            </p> */}
          <FormGroup>
            <Button className="w-100" color="primary" block>Submit</Button>
          </FormGroup>
        </fieldset>
      </Form>
    </div>
  </div>
);

export default ForgotPassword;
